import moment from 'moment';

export const DEFAULT_STATE_CSM = {
    requested: false,
    requestedUser: null,
    requestedUserLogin: null,
    requestedTimestamp: null,
    requestedWho: null,
    requestedWhen: moment(),
    requestedNote: '', // ED Note

    allocated: false,
    allocatedUser: null,
    allocatedUserLogin: null,
    allocatedTimestamp: null,
    allocatedWho: null,
    allocatedWhen: null,
    allocatedNote: '', // Ward Feedback

    ready: false,
    readyUser: null,
    readyUserLogin: null,
    readyTimestamp: null,
    readyWho: null,
    readyWhen: null,
    readyNote: '',

    canceled: false,
    canceledUser: null,
    canceledUserLogin: null,
    canceledTimestamp: null,
    canceledWho: null,
    canceledWhen: null,
    canceledNote: '',

    sideRoom: false,
    sideRoomUser: null,
    sideRoomUserLogin: null,
    sideRoomTimestamp: null,
    sideRoomNote: '',

    anotherDestination: '',
    anotherDestinationUser: null,
    anotherDestinationUserLogin: null,
    anotherDestinationTimestamp: null,
    anotherDestinationNote: '',

    withinHour: null,
    withinHourUser: null,
    withinHourUserLogin: null,
    withinHourTimestamp: null,
    withinHourTimesToTrack: null,
    withinHourNote: '',

    onHoldWard: false,
    onHoldWardUser: null,
    onHoldWardUserLogin: null,
    onHoldWardTimestamp: null,
    onHoldWardTimesToTrack: null,
    onHoldWardNote: '',

    patientPost: false,
    patientPostUser: null,
    patientPostUserLogin: null,
    patientPostTimestamp: null,
    patientPostTimesToTrack: null,
    patientPostNote: '',

    reasonForAdmissions: '',
    activityTreatment: null,
    ward: null,

    when: null,
    lastUser: null,
    lastUserLogin: null,
};